import { classNames } from 'helpers'
import React, { useContext } from 'react'
import FieldContext from './FieldContext'
export interface InputProps
  extends React.ComponentPropsWithRef<'input'> {
  outlined?: boolean
  shadow?: boolean
  icon?: any
  rounded?: boolean
  className?: string
}

const styles = {
  base: 'block w-full text-base',
  icon: 'pl-14',
  outlined: 'border border-gray-1',
  notOutline: 'border-white',
  shadow: 'shadow-sm',
  rounded: 'rounded-md',
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type,
      outlined,
      shadow,
      icon,
      rounded,
      className,
      children,
      ...args
    },
    ref
  ) => {
    const id = useContext(FieldContext)
    const Icon = icon

    return (
      <div
        className={`mt-1 relative rounded-md inline-flex items-center justify-center h-10 w-full ${className}`}
      >
        {Icon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <div className="flex items-center justify-center w-6 h-full px-0.5 py-0.5">
              <Icon
                className="w-5 h-5 bg-opacity-50"
                aria-hidden="true"
              />
            </div>
          </div>
        )}
        <input
          type={type}
          id={id}
          ref={ref}
          className={classNames(
            styles.base,
            icon && styles.icon,
            outlined ? styles.outlined : styles.notOutline,
            shadow && styles.shadow,
            rounded && styles.rounded,
            className,
            !className?.includes('ring') &&
              'focus:ring-indigo-2 focus:border-indigo-2'
          )}
          {...args}
        />
        {children}
      </div>
    )
  }
)

Input.defaultProps = {
  type: 'text',
  outlined: true,
  shadow: true,
  icon: false,
}

export default Input
